import type { App } from 'vue'
import ErrorHandler from '@/models/ErrorHandler.ts'
import { errorHandlerKey } from '@/config/keys.ts'

export default {
    install(app: App) {
        const errorHandler = new ErrorHandler(app)

        app.config.errorHandler = (err, instance, info) => {
            errorHandler.captureError(err, 'globalErrorHandler', {
                vueInfo: info,
                place: 'global error handler',
            })
            console.error(err)
        }

        app.provide(errorHandlerKey, errorHandler)
    },
}
